import { type AnalyticsEvent } from '@autone/analytics';
import { type FC, type PropsWithChildren } from 'react';

import {
  cn,
  CopyButton,
  DataTableCellSubtitle,
  LongText,
  useFullscreenContext,
} from '../../../tailwind';
import { PeakViewTooltipButton } from '../../peak-view';

interface Props extends PropsWithChildren {
  productId?: string | null;
  analyticsEvent?: AnalyticsEvent;
  className?: string;
  alwaysShowIcons?: boolean;
  maxLength?: number;
}

export const ProductId: FC<Props> = ({
  productId,
  analyticsEvent,
  className,
  alwaysShowIcons = false,
  maxLength = 20,
}) => {
  const { fullscreenContainer, isFullscreen } = useFullscreenContext();
  if (!productId) {
    return null;
  }

  return (
    <DataTableCellSubtitle className="uppercase flex flex-row gap-1 items-center group w-fit">
      <LongText value={productId} maxLength={maxLength} className={className} />
      <CopyButton
        data-testid={`copy-product-id-${productId}`}
        color="primary"
        className={cn(
          'opacity-0 group-hover:opacity-100 h-full',
          alwaysShowIcons && 'opacity-100',
        )}
        value={productId}
        analyticsEvent={analyticsEvent}
        container={fullscreenContainer}
      />
      <div
        className={cn(
          'opacity-0 group-hover:opacity-100',
          alwaysShowIcons && 'opacity-100',
        )}
      >
        <PeakViewTooltipButton
          productId={productId}
          isFullScreen={isFullscreen}
          fullScreenContainer={fullscreenContainer}
        />
      </div>
    </DataTableCellSubtitle>
  );
};
